export const MENU_ITEM_ACTIVE = 'MENU_ITEM_ACTIVE';
export const IS_SHOW_LIST_MENU_IN_RESPONSIVE = 'IS_SHOW_LIST_MENU_IN_RESPONSIVE';
export const IS_HIDE_LIST_MENU_IN_RESPONSIVE = 'IS_HIDE_LIST_MENU_IN_RESPONSIVE';

export default this;
